import { postData } from "./http-service";


export const getAllNotesByEmployeeId = async (employeeId) => {
  try {
    const response = await postData({
      method: "GET",
      path: "notes/employee-list",
      options: `?employeeId=${employeeId}`,
      showToaster: false,
    });
    if (response.ok) {
      return await response.json();
    }
  } catch (error) {
    return null;
  }
};

  export const createNote= async (note) => {
    try {
      const response = await postData({
        path: "notes/create",
        data: note,
        api: "api",
        toasterMessage: "Note Successfully Created!",
      });
      if (response.ok) {
        return await response.json();
      }
    } catch (error) {
      return null;
    }
  };

  export const updateNote = async (noteData) => {
    try {
      const response = await postData({
        method: "POST",
        path: "notes/update-details",
        data: noteData,
        toasterMessage: "Note Successfully Updated!",
      });
      if (response.ok) {
        return await response.json();
      }
    } catch (error) {
      return null;
    }
  };

  export const deleteNote = async (noteId) => {
    try {
      const response = await postData({
        path: "notes/delete",
        options: `?noteId=${noteId}`,
        showToaster: false,
      });
      if (response.ok) {
        return await response.json();
      }
    } catch (error) {
      return null;
    }
  };